import { render, staticRenderFns } from "./MultilingualTextField.vue?vue&type=template&id=50c0e4ca&scoped=true"
import script from "./MultilingualTextField.vue?vue&type=script&lang=js"
export * from "./MultilingualTextField.vue?vue&type=script&lang=js"
import style0 from "./MultilingualTextField.vue?vue&type=style&index=0&id=50c0e4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c0e4ca",
  null
  
)

export default component.exports